<template>
  <div>
    <div v-if="menus.length > 1" class="menu-wrapper w-100 d-flex">
      <button
        v-for="(menu, index) in menus"
        :class="{ 'menu-active': activeIndex == index }"
        :key="index"
        @click="setActiveMenu(index)"
        class="menu mr-1"
      >
        <div class="font-weight-bold">{{ menu.title }}</div>
        <div class="text-opacity-muted text-sm">{{ menu.short_description }}</div>
      </button>
    </div>
    <LunchMenuList v-if="menus.length > 0" :menu="activeMenu" :t="t" :crop-content="cropContent" />
  </div>
</template>

<script>
import LunchMenuList from "./LunchMenuList";
import { mapActions } from "vuex";

export default {
  name: "LunchMenuView",
  components: {
    LunchMenuList,
  },
  props: {
    menus: {
      type: Array,
      required: true,
    },
    cropContent: {
      type: Boolean,
      default: false,
      required: false,
    },
    t: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
      open: false,
    };
  },
  computed: {
    activeMenu() {
      return this.menus[this.activeIndex];
    },
  },
  mounted() {
    this.setActiveMenu(0);
  },
  methods: {
    ...mapActions({
      setMenu: "lunchMenu/setMenu",
    }),
    setActiveMenu(index) {
      this.activeIndex = index;
      this.setMenu(this.menus[index]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.menu-wrapper {
  overflow-x: auto;

  &::after {
    content: "";
    flex-shrink: 0;
    width: $spacer / 2;
  }
}

.menu {
  flex-shrink: 0;
  border-radius: $border-radius;
  padding: $spacer-2;
  text-align: left;
  border: $width-border-medium solid $secondary-700;
  color: $gray-900;
  background: transparent;
  min-width: 130px;
  transition-property: background-color, border-color;
  transition-duration: $transition-duration;

  &:focus {
    outline: none;
    border-color: $secondary;
  }

  &:hover {
    background-color: $gray-200;
  }
}

.menu-active {
  background-color: $secondary-700;
  color: $white;

  &:hover {
    background-color: $secondary;
  }
}

.intro-name {
  font-size: $h6-font-size;

  @media (min-width: $screen-sm-min) {
    font-size: $h2-font-size;
  }
}
</style>
